import React, { useEffect, useState } from "react";
import GroupOrder from "../../assets/GroupOrder.png";
import calender from "../../assets/calender.png";
import profile from "../../assets/profile.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import statusIcon from "../../assets/orders/status.png";
import stepsPrice from "../../assets/orders/stepsPrice.png";
import stepsCompleted from "../../assets/orders/stepsCompleted.png";
import { Button, Carousel, Checkbox, Input, Modal, Radio, Space } from "antd";
import credit from "../../assets/checkout/credit.png";
import cash from "../../assets/checkout/cash.png";
import { useDispatch, useSelector } from "react-redux";
import { paymentTypeFunction } from "../../redux/paymentTypeSlice";
import check from "../../assets/orders/check.png";
import visa from "../../assets/checkout/visa.png";
import { fetchUser } from "../../redux/getUserSlice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Payment = ({
  idOrder,
  image,
  date,
  time,
  addresss,
  description,
  statuss,
  images,
  clear_price,
  payment_method,
  agentName,
  AgentImage,
  updated_atDate,
  updated_at,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalView, setIsModalView] = useState(false);

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { getUser } = useSelector((state) => state.getUser);

  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch]);

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const onFinish = (values) => {
    console.log("Form Data:", values);
  };

  const [phone, setPhone] = useState("");
  const [selected, setSelected] = useState("evaluation");

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const [value, setValue] = useState(1);
  const onChangeShipping = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const [pay, setPay] = useState("cash");
  const [walletPay, setWalletPay] = useState(0);
  const [walletMoney, setWalletMoney] = useState("");
  const [walletError, setWalletError] = useState("");
  // const [method, setMethod] = useState(true);

  const onChangePay = (e) => {
    console.log("radio checked", e.target.pay);
    setPay(e.target.value);
  };

  const onChangeWallet = (e) => {
    const checked = e.target.checked;
    console.log("Use my wallet:", checked);
    setWalletPay(checked ? 1 : 0);
    if (!checked) {
      setWalletMoney("");
      setWalletError("");
    }
  };

  const onChangeWalletMoney = (e) => {
    const value = e.target.value;
    const totalWallet = getUser?.total_wallet || 0;

    if (value > totalWallet) {
      setWalletError(`${t("Amount exceeds your wallet balance of")} ${totalWallet}`);
    } else if (value <= 0) {
      setWalletError(t("Amount must be greater than 0"));
    } else {
      setWalletError("");
    }

    setWalletMoney(value);
  };

  const { status, error } = useSelector((state) => state.paymentType);

  // const handleMethod = async (e) => {
  //   e.preventDefault();

  //   const payload = {
  //     order_id: idOrder,
  //     type: pay,
  //     wallet_pay: walletPay,
  //     wallet_money: walletPay === 1 ? walletMoney : undefined,
  //     order_status: "order",
  //   };

  //   try {
  //     const result = await dispatch(paymentTypeFunction(payload)).unwrap();
  //     console.log("Payment successful:", result);

  //     if (pay === "visa" && typeof result === "string") {
  //       const urlMatch = result.match(/content="1;URL='(.*?)'/);
  //       if (urlMatch && urlMatch[1]) {
  //         const url = urlMatch[1];
  //         console.log("Redirecting to:", url);
  //         window.location.href = url;
  //       } else {
  //         console.error("URL not found in response.");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Payment failed:", error);
  //   }
  // };

  const handleMethod = async (e) => {
    e.preventDefault();

    const payload = {
      order_id: idOrder,
      type: pay,
      wallet_pay: walletPay,
      wallet_money: walletPay === 1 ? walletMoney : undefined,
      order_status: "order",
    };

    try {
      const result = await dispatch(paymentTypeFunction(payload)).unwrap();
      console.log(t("Payment response"), result);

      if (result.payment_url) {
        window.open(result.payment_url, "_blank");
      } else {
        console.error(t("Payment URL not found in the response."));
      }
    } catch (error) {
      console.error(t("Payment failed"), error);
    }
  };

  return (
    <div>
      <div className="pb-4">
        <img
          src={image}
          className="w-[120px] bg-[#FCFBFA] p-3 rounded-2xl mx-auto my-5"
        />
        <div className="text-center">
          <p className="text-[#737E91] font-semibold text-xl">
            {t("Order number")}
            <span className="text-[#283D63] font-semibold">#{idOrder}</span>
          </p>
          <p className="text-[#A6ADB9] mt-2">
            {t("Order created on")} {updated_atDate} <br /> {updated_at}
          </p>
        </div>

        {payment_method == null || payment_method == "visa" ? (
          <img src={stepsPrice} className="w-[300px] mx-auto my-5" />
        ) : (
          <img src={stepsCompleted} className="w-[300px] mx-auto my-5" />
        )}

        <div className="bg-[#FCFBFA] rounded-2xl font-medium w-[300px] p-5 mx-auto text-lg">
          <h3 className="text-[#525D71] text-xl">{t("Confirmed Pricing")}</h3>
          <p className="text-[#A4ADBC] mt-3">{t("Price")}</p>
          <p className="text-[#FE9B71]">
            {clear_price} {t("SR")}
          </p>
        </div>

        {payment_method == null ? (
          <div className="mx-auto">
            <Checkbox
              onChange={onChangeWallet}
              className="text-[#283D63] font-medium text-lg my-4 flex mx-auto justify-center"
            >
              {t("Use my wallet")}
            </Checkbox>

            {walletPay === 1 && (
              <div className="flex flex-col items-center my-2 mb-5">
                <input
                  type="text"
                  id="walletMoney"
                  value={walletMoney}
                  onChange={onChangeWalletMoney}
                  className="border rounded-lg p-2 mt-1 text-center w-1/2"
                  placeholder={t("Enter amount")}
                  required
                />
                {walletError && (
                  <p className="text-red-500 text-sm mt-1">{walletError}</p>
                )}
              </div>
            )}

            <div>
              <form onSubmit={handleMethod}>
                <div className="grid grid-cols-2 gap-10 max-lg:gap-4 max-xl:grid-cols-1 lg:items-center">
                  <div className="bg-[#FCFBFA] rounded-2xl">
                    <div className="flex items-center justify-between bg-[#FCFBFA] rounded-2xl px-5 py-4">
                      <Radio.Group
                        onChange={onChangePay}
                        value={pay}
                        className="custome_radio text-lg text-[#525A6B]"
                      >
                        <Space direction="vertical">
                          <Radio value="visa">{t("CreditDebit Card")}</Radio>
                        </Space>
                      </Radio.Group>
                      <div>
                        <img src={credit} className="w-[30px]" />
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between bg-[#FCFBFA] rounded-2xl px-5 py-4">
                    <Radio.Group
                      onChange={onChangePay}
                      value={pay}
                      className="custome_radio text-lg text-[#525A6B]"
                    >
                      <Space direction="vertical">
                        <Radio value="cash">{t("Cash on Delivery")}</Radio>
                      </Space>
                    </Radio.Group>
                    <div>
                      <img src={cash} className="w-[30px]" />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  onClick={handleMethod}
                  // disabled={status === "loading"}
                  disabled={
                    status === "loading" ||
                    (walletPay === 1 && (walletError || walletMoney <= 0))
                  }
                  className="bg-[#FE9B71] text-white rounded-full py-3 px-14 mt-4 flex mx-auto font-medium text-lg"
                >
                  {status === "loading" ? t("Processing...") : t("Proceed")}
                </button>
                {error && (
                  <p className="text-red-500 text-center mt-2">{error}</p>
                )}
              </form>
            </div>
          </div>
        ) : (
          <>
            {/* <form className="my-5 mx-7 max-lg:mx-3">
              <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-7">
                <div>
                  <p className="text-[#283D63] font-semibold">
                    Card Name <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Input
                    placeholder="Eg. Johnny Noe"
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </div>

                <div className="mt-5">
                  <p className="text-[#283D63] font-semibold">
                    Card Number <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Input
                    placeholder="0000 0000 0000 0000"
                    value={cardNumber}
                    onChange={handleCardNumberChange}
                    suffix={<img src={visa} className="w-[70px]" />}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </div>

                <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-5">
                  <div>
                    <p className="text-[#283D63] font-semibold">
                      Expiry Date <span className="text-[#CC0F0F]">*</span>
                    </p>
                    <Input
                      placeholder="MM/YY"
                      value={expiryDate}
                      onChange={handleExpiryDateChange}
                      className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    />
                  </div>
                  <div>
                    <p className="text-[#283D63] font-semibold">
                      Cvv <span className="text-[#CC0F0F]">*</span>
                    </p>
                    <Input
                      placeholder="123"
                      value={cvv}
                      onChange={handleCvvChange}
                      className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    />
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className="bg-[#FE9B71] text-white rounded-full py-3 px-14 mt-4 flex mx-auto font-medium text-lg"
              >
                Proceed
              </button>
            </form> */}
            {/* <p className="text-red-500 text-center text-xl mt-5">
              Please pay in the link
            </p> */}
            <div className="mx-auto text-center">
              <img src={check} className="w-[50px] mx-auto my-5" />
              <p className="text-[#525D71] font-semibold">
                {t("Payment Method Confirmed")}
              </p>
            </div>
            {payment_method == "cash" && (
              <div className="bg-[#FCFBFA] rounded-2xl my-5 px-7 py-4">
                <div className="flex items-center">
                  {AgentImage == null ? (
                    <img
                      src={profile}
                      className={`w-[48px] ${
                        language == "en" ? "mr-3" : "ml-3"
                      }`}
                    />
                  ) : (
                    <img
                      src={AgentImage}
                      className={`w-[48px] ${
                        language == "en" ? "mr-3" : "ml-3"
                      } rounded-full`}
                      onError={(e) => (e.target.src = profile)}
                    />
                  )}
                  <p className="text-[#525D71] font-medium text-lg">
                    {agentName} {t("will accept")} {payment_method} {t("payment only")}
                  </p>
                </div>
              </div>
            )}
          </>
        )}

        <div className="px-5 mt-4">
          <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
            <div className="flex items-center mt-3 ">
              <img
                src={calender}
                className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
              />
              <p className="text-[#283D63] font-medium">
                {date} | {time}
              </p>
            </div>
            <div className="flex items-center mt-3 ">
              <img
                src={address}
                className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
              />
              <p className="text-[#283D63] font-medium">{addresss}</p>
            </div>
          </div>

          <div className="flex items-start mt-5 ">
            <img
              src={desc}
              className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
            />
            <p className="text-[#283D63] font-medium">{description}</p>
          </div>

          <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
            <div className="flex items-center mt-5 ">
              <img
                src={upload}
                className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
              />
              {images?.length > 0 ? (
                <>
                  <button
                    onClick={showModalView}
                    className="text-[#6682B6] underline font-medium"
                  >
                    {t("View Uploaded Images")}
                  </button>
                  <Modal
                    title={t("Uploaded Images")}
                    className="orderModal orderModalPricing w_small_modal"
                    open={isModalView}
                    onOk={handleOkView}
                    onCancel={handleCancelView}
                    footer={null}
                  >
                    <Carousel
                      arrows
                      infinite={false}
                      className="custome_carousel_images"
                    >
                      {images?.map((img, index) => (
                        <div key={index}>
                          <img
                            src={`https://service.samoolah.com/${img}`}
                            alt={`Uploaded image ${index + 1}`}
                            className="w-[120px] mx-auto my-5"
                          />
                        </div>
                      ))}
                    </Carousel>
                  </Modal>
                </>
              ) : (
                <p className="text-[#283D63] font-medium">
                  {t("No Uploaded Images")}
                </p>
              )}
            </div>
            <div className="flex items-center mt-3 ">
              <img
                src={statusIcon}
                className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
              />
              <p className="text-[#737E91] font-medium">{t("Status")}</p>
              <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>
                 {t("Pricing")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;
